import vue from '@/main'
import rawAxios from "axios"
import axios from "../../axios"

export default {
  delete(filename, headers) {
    vue.$vs.loading({
      type: 'radius',
      text: 'Removendo arquivo...'
    });

    return new Promise((resolve, reject) => {
      rawAxios.delete(
        `${localStorage.getItem('baseUrl')}/api/file/delete/${filename}`,
        { headers }
      )
      .then(() => {
        vue.$vs.loading.close()
        resolve(true)
      })
      .catch(() => {
        vue.$vs.loading.close()
        reject(false)
      })
    })
  },
  async upload(file, tenantName = '') {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('tenantName', tenantName);
    return axios.post(
      `${process.env.VUE_APP_API_BASE_URL}/api/file/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  }
}